import { Component} from '@angular/core';

@Component({
    selector: 'group-main',
    templateUrl: './group-main.tmpl.html'
})

export class GroupMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  